'use client';

import styled from '@emotion/styled';
import { Box, BoxProps } from '@mui/material';
import React from 'react';

type Props = BoxProps;

export const Spacer = (props: Props) => <SpacerLine {...props} />;

const SpacerLine = styled(Box)`
    border-bottom: ${({ theme }) => `1px solid ${theme.colors.outline}`};
`;
